export default {
  'In-game ui setting': 'In-game UI setting',
  ai: 'AI',
  'arts/ui': 'Arts/UI',
  'ip corporation': 'IP corporation',
  'mmo/regular': 'MMO/regular',
  pve: 'PvE',
  'pvp arena': 'PVP arena',
  'ui design': 'UI design',
  'ui/ux': 'UI/UX',
};
